import React from 'react';
import dayjs from 'dayjs';

import Button from '@material-ui/core/Button'
import { CardActions, CardContent, Grid } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';

import Spacer from '../../../app/common/ui/Spacer';
import getStateColour from '../../../app/colours.js';
import ArchiveItemButton from '../_common/ArchiveItemButton';

const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

const MemberReferralCard = ({ rfq, onClick }) => {

    const dt = new Date(rfq.ts);
    const rfqTimeStamp = `${dt.toLocaleString("en-GB", options)} at ${dt.toLocaleTimeString("en-GB", { hour: '2-digit', minute: '2-digit' })}`;
    const age = dayjs(new Date()).diff(dt, 'hour');

    const akas = new Map(
        [
            ['active', 'quote in progress'],
            ['completed', 'quote provided'],
        ]
    );

    return (
        <Card
            onClick={onClick}
            style={{ marginBottom: '1rem' }}
        >
            <CardContent>
                <Grid container spacing={1}>
                    <Grid item><Typography variant="button" color="textSecondary">REFERRAL</Typography></Grid>
                    <Grid item style={{ marginLeft: 'auto' }}><Chip label={akas.get(rfq.status) || rfq.status} style={{ color: 'white', backgroundColor: getStateColour(rfq.status) }} size="small" /></Grid>
                </Grid>
                <Typography variant="subtitle2">From {rfq.organization}</Typography>
                <Typography variant="subtitle2" color={age >= 24 && rfq.status === 'new' ? "secondary" : "inherit"}>{`Received on ${rfqTimeStamp}`}</Typography>
                <Spacer space='0.25rem' />
                <Typography variant="subtitle2" color="textSecondary">Reference {rfq.referral?.bookingReference}</Typography>
                {/* <Typography variant="subtitle2" color="textSecondary">Court Case Number {courtCase?.courtCaseNumber}</Typography> */}
                <Spacer space='0.5rem' />

                <Typography variant="body2">{rfq.message}</Typography>
                <Spacer space='0.5rem' />
                <Typography variant="subtitle2">Timescales</Typography>
                <Typography variant="body2">{rfq.dates || '?'}</Typography>
            </CardContent>
            <CardActions>
                <Button variant="text" color="primary" href={`/casework/referral/${rfq.referralId}`}>View Referral</Button>
                {rfq.status === 'new' && <Button variant="text" color="secondary" href={`/casework/referral/decline/${rfq.id}`}>Decline Referral</Button>}
                {rfq.status === 'active' && <Button variant="text" color="primary" href={`/casework/quote/${rfq.id}`}>View Quote</Button>}
                {rfq.status === 'declined' && <Button variant="text" color="primary" href={`/casework/referral/${rfq.id}`}>View Referral</Button>}
                <div style={{ marginLeft: 'auto' }}>
                    <ArchiveItemButton doc={rfq} docType="referral" />
                </div>
            </CardActions>
        </Card>
    );
};

export default MemberReferralCard;